import {Component, OnInit, Input} from '@angular/core';
import { ThingsUtil } from '../../../util/things';
import { THINGS_ATTRIBUTES_CONFIG } from "../../../constants/things.constants";

@Component({
  selector: 'things-attributes',
  templateUrl: './attributes.component.html',
  styleUrls: ['./attributes.component.less']
})
export class ThingsAttributesComponent implements OnInit {

  @Input()
  public thing: any = {};

  public attributeConfig;

  constructor(private thingsUtil: ThingsUtil) { }

  refreshData() {
    this.attributeConfig = this.getAttributeConfig();
  }

  ngOnInit() {
    this.refreshData();
  }

  getAttributeConfig() {
    return THINGS_ATTRIBUTES_CONFIG[this.thing.type] || [];
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/attributes/attributes.component.ts